import styled from 'styled-components'
import { AdvantagesElement } from 'Pages/landings/newLandings/common/components'
import {
	WrapperBlock,
	gridThree,
	Breakpoints,
	media,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperBlock)`
	column-gap: 32px;
	${gridThree};
	padding: 0 32px;
	${media('padding: 0 72px;', Breakpoints.lx)}
	${media('padding: 0;', Breakpoints.xl)}
`

export const Element = styled(AdvantagesElement)`
	margin: 0;
	padding: 0;
`
